import React, { createContext, useContext, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Museum } from '@/shared/types';
import { isReservedRootPath } from '@/features/museum/utils/museum';
import { getFirebaseDb } from '@/shared/services/firebase/config';
import { getDoc, doc } from 'firebase/firestore';
import { logger } from '@/shared/utils/logger';

interface MuseumContextType {
  museumSlug: string | null;
  museum: Museum | null;
  loading: boolean;
}

const MuseumContext = createContext<MuseumContextType | undefined>(undefined);

export const MuseumProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [museumSlug, setMuseumSlug] = useState<string | null>(null);
  const [museum, setMuseum] = useState<Museum | null>(null);
  const [loading, setLoading] = useState(true);
  const location = useLocation();

  useEffect(() => {
    const fetchMuseum = async () => {
      // Récupérer le slug depuis les paramètres de route ou depuis l'URL
      const pathParts = location.pathname.split('/').filter(Boolean);
      const slug = pathParts[0] && !isReservedRootPath(pathParts[0]) ? pathParts[0] : null;

      setMuseumSlug(slug);

      if (slug) {
        const db = getFirebaseDb();
        if (db) {
          try {
            const museumDoc = await getDoc(doc(db, 'museums', slug));
            if (museumDoc.exists()) {
              const museumData = museumDoc.data();
              logger.log('museumDoc data:', museumData);
              logger.log('museumDoc plans:', museumData.plans);
              const museum = { id: museumDoc.id, ...museumData };
              setMuseum(museum as Museum);
            }
          } catch (error) {
            logger.error('Erreur lors de la récupération du musée:', error);
          }
        }
      }

      setLoading(false);
    };

    fetchMuseum();
  }, [location.pathname]);

  return (
    <MuseumContext.Provider value={{ museumSlug, museum, loading }}>
      {children}
    </MuseumContext.Provider>
  );
};

export const useMuseum = () => {
  const context = useContext(MuseumContext);
  if (context === undefined) {
    throw new Error('useMuseum must be used within a MuseumProvider');
  }
  return context;
};

